<template>
  <or-layout>
    <a-row :gutter="[16, 16]" type="flex" justify="space-between">
      <a-col :span="24">
        <a-form layout="inline">
          <a-form-item>
            <a-input v-model="form.student_name" allowClear placeholder="学生名称"></a-input>
          </a-form-item>
          <a-form-item>
            <a-input v-model="form.student_mobile" allowClear placeholder="学生电话"></a-input>
          </a-form-item>
          <a-form-item>
            <a-select v-model="form.pass_flag" placeholder="状态" allowClear style="width: 150px;"
                      :loading="loading">
              <a-select-option value="-1">待审核</a-select-option>
              <a-select-option value="0">合格</a-select-option>
              <a-select-option value="1">不合格</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" htmlType="submit" icon="search" @click="searchbtn"/>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <div>
      <a-table :dataSource="testpaperList" :pagination="pageinfo" :loading="loading" @change="onPaginationChange"
               rowKey="id">
        <a-table-column width="80px" data-index="id" title="序号"></a-table-column>
        <a-table-column width="120px" data-index="campus_name" title="校区名字"></a-table-column>
        <a-table-column width="100px" data-index="teacher_name" title="老师名字"></a-table-column>
        <a-table-column width="120px" data-index="dept_name" title="岗位名字"></a-table-column>
        <a-table-column width="100px" data-index="student_name" title="学生名称"></a-table-column>
        <a-table-column width="120px" data-index="student_mobile" title="学生电话"></a-table-column>
        <a-table-column width="100px" data-index="ah_school_name" title="就读校区"></a-table-column>
        <a-table-column width="100px" data-index="fenshu" title="入学分数"></a-table-column>
        <a-table-column width="100px" data-index="grade_name" title="年级名称"></a-table-column>
        <a-table-column width="100px" data-index="new_type" title="新招类型"></a-table-column>
        <a-table-column width="100px" data-index="subject_name" title="学科名称"></a-table-column>
        <a-table-column width="100px" data-index="pay_cost" title="缴费金额"></a-table-column>
        <a-table-column width="120px" data-index="pay_date" title="缴费日期"></a-table-column>
        <a-table-column width="110px" data-index="student_school_name" title="全日制学校"></a-table-column>
        <a-table-column width="110px" data-index="is_intro" title="是否转介绍"></a-table-column>
        <a-table-column width="110px" data-index="intro_name" title="转介绍名字"></a-table-column>
        <a-table-column key="pass_flag" width="120px" title="状态">
          <template slot-scope="item">
            <span v-if="item.pass_flag===0">合格</span>
            <span v-if="item.pass_flag===1">不合格</span>
            <span v-if="item.pass_flag===-1">待审核</span>
          </template>
        </a-table-column>
        <a-table-column width="120px" data-index="remarks" title="审核备注"></a-table-column>
        <a-table-column width="160px" key="create_time" title="上传时间">
          <template slot-scope="item">
            {{ item.create_time }}
          </template>
        </a-table-column>
        <a-table-column key="view_show" width="60px" title="试卷">
          <template slot-scope="item">
            <a @click="show_video(item.shijuan1,item.shijuan2,item.fujian1,item.fujian2)">查看</a>
          </template>
        </a-table-column>
      </a-table>
    </div>

  </or-layout>
</template>

<script>
export default {
  data() {
    return {
      video_visible: false,
      media_path: "",
      form: {
        student_name: undefined,
        student_mobile: undefined,
        pass_flag: undefined
      },
      subjectType: ['全部', '数学', '英语', '语文', '化学', '物理'],
      testpaperList: [],
      loading: false,
      gradeList: [],
      campusList: [],
      pageinfo: {
        showTotal: total => `共 ${this.pageinfo.total} 条`,
        showSizeChanger: true,
        total: 1,
        current: 1,
        pageSize: 10,
        allCnt: 0
      },
    }
  },
  created() {
    this.searchbtn()
  },
  methods: {
    show_video(img1, img2, img3, img4) {
      this.$viewerApi({
        images: [img1, img2, img3, img4],
      })
    },
    onChange(value, dateString) {
      dateString,
          this.form.start_time = parseInt(value[0] / 1000);
      this.form.end_time = parseInt(value[1] / 1000);
    },
    startChange(value, dateString) {
      this.form.start_time = parseInt(Date.parse(value) / 1000);
    },
    endChange(value, dateString) {
      this.form.end_time = parseInt(Date.parse(value) / 1000);
    },
    onPaginationChange(item) {
      this.pageinfo.pageSize = item.pageSize;
      this.pageinfo.current = item.current;
      this.searchbtn()
    },
    async searchbtn() {
      this.loading = true;
      try {
        let {data: {data, pageinfo}}  = await this.$axios.post('/api/Ksinfo/getksinfolistTeacher', {data: this.form,   pageinfo: this.pageinfo});
        this.loading = false;
        this.testpaperList = data;
        this.pageinfo = pageinfo;
      } catch (error) {
        this.loading = false;
      }
    }
  }
}
</script>
<style lang="less" scoped></style>